import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Button } from "./ui/button";
import { Link, useLocation } from "react-router-dom";

export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { path: "/", label: "Home" },
    { path: "/about", label: "About Us" },
    { path: "/services", label: "Services" },
    { path: "/contact", label: "Contact Us" },
  ];

  return (
      <header className="sticky top-0 z-50 bg-white">
        {/* Promotional Banner */}
        <div className="bg-[#075123] text-white py-2">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <p className="text-sm md:text-base">
              🎯 <strong>Free Visual Inspection</strong> |{" "}
              <a href="tel:3062017883" className="hover:text-yellow-300">
                Call Now: (306) 201-7883
              </a>{" "}
              |{" "}
              <a href="tel:3065371423" className="hover:text-yellow-300">
                Call Now: (306) 537-1423
              </a>
            </p>
          </div>
        </div>

        {/* Navbar container */}
        <div className="bg-white shadow-md relative">
          <div className="px-4 sm:px-6 lg:px-8">

            {/* DESKTOP HEADER */}
            <div className="hidden md:flex justify-between items-center h-32 pt-2">
              {/* Logo + slogan */}
              <div className="flex items-center">
                <Link
                    to="/"
                    className="w-48 h-48 bg-white rounded-full shadow-2xl flex items-center justify-center border-4 border-gray-200 hover:border-green-600 transition-all duration-300 hover:shadow-green-500/20"
                >
                  <img
                      src="/logo.png"
                      alt="BugBuddies Pest Solutions"
                      className="h-28 w-auto"
                      loading="eager"
                      decoding="async"
                  />
                </Link>
                <Link
                    to="/"
                    className="flex flex-col text-left ml-4 justify-center"
                >
                <span className="text-lg text-[#075123] italic font-bold hidden sm:block">
                  "They can run... But they can't hide!"
                </span>
                </Link>
              </div>

              {/* Desktop Navigation */}
              <nav className="flex items-center space-x-8">
                {navItems.map((item) => (
                    <Link
                        key={item.path}
                        to={item.path}
                        className={`px-4 py-2 rounded-md transition-all duration-300 font-bold ${
                            location.pathname === item.path
                                ? "text-[#075123] bg-green-50 shadow"
                                : "text-gray-700 hover:text-[#075123] hover:bg-green-50"
                        }`}
                    >
                      {item.label}
                    </Link>
                ))}
              </nav>
            </div>

            {/* MOBILE HEADER */}
            <div className="flex md:hidden justify-between items-center h-20">
              {/* Compact Logo + slogan */}
              <Link
                  className="flex items-center gap-3 flex-1"
                  to="/"
                  aria-label="Go to Home"
              >
                <img
                    src="/logo.png"
                    alt="BugBuddies Pest Solutions"
                    className="h-16 w-auto"
                    loading="eager"
                    decoding="async"
                />
                <span className="text-sm text-[#075123] italic truncate max-w-[35ch]">
                "They can run... But they can't hide!"
              </span>
              </Link>

              {/* Mobile menu toggle */}
              <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => setIsMenuOpen(!isMenuOpen)}
                  aria-expanded={isMenuOpen}
                  aria-label="Toggle menu"
                  className="text-gray-700"
              >
                {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
              </Button>
            </div>

            {/* Mobile Navigation */}
            {isMenuOpen && (
                <div className="md:hidden">
                  <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white border-t">
                    {navItems.map((item) => (
                        <Link
                            key={item.path}
                            to={item.path}
                            onClick={() => setIsMenuOpen(false)}
                            className={`block w-full text-left px-3 py-2 rounded-md transition-all duration-300 ${
                                location.pathname === item.path
                                    ? "text-[#075123] bg-green-50"
                                    : "text-gray-700 hover:text-[#075123] hover:bg-green-50"
                            }`}
                        >
                          {item.label}
                        </Link>
                    ))}
                  </div>
                </div>
            )}

          </div>
        </div>
      </header>
  );
}
